import React from "react";
import CashRegisterGenericSkeleton from "./CashRegisterGenericSkeleton";

function CashRegisterDetailSkeleton() {
  return (
    <>
      <CashRegisterGenericSkeleton />
    </>
  );
}

export default CashRegisterDetailSkeleton;
